import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f2ebf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-confirmation" }
const _hoisted_2 = { class: "m-confirmation-inner" }
const _hoisted_3 = {
  key: 0,
  class: "m-confirmation-form"
}
const _hoisted_4 = ["disabled"]

import { computed, reactive, ref, watch } from "vue";
import { TransactionState } from "@manifoldxyz/collectible-sdk";
import { useCollectibleSDK } from "@/composables/useCollectibleSDK";
import { useMessaging } from "@/composables/useMessaging";
import { useStore } from "@/composables/useStore";
import CrossmintPayButton from "./CrossmintPayButton.vue";
import PurchaseAmount from "./PurchaseAmount.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseConfirmation',
  props: {
    defaultPurchaseQuantity: {}
  },
  emits: ["purchase"],
  setup(__props: any, { emit }) {

const props = __props;


const componentState = reactive<{
  purchaseQuantity: number;
  recaptchaToken: string;
  transactionState: TransactionState | null;
}>({
  purchaseQuantity: props.defaultPurchaseQuantity || 1,
  recaptchaToken: "",
  transactionState: null,
});
const collectibleSDK = useCollectibleSDK();

const store = useStore();


const isButtonDisabled = computed(() => {
  return !store.userCanPurchase || !(store.walletAddress && componentState.recaptchaToken);
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emitPurchase = () => {
  emit("purchase", componentState.purchaseQuantity, componentState.recaptchaToken);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const onCrossmintClick = () => {
  window.grecaptcha.reset();
  componentState.recaptchaToken = "";
};

const recaptchaRef = ref(null);
watch(recaptchaRef, async () => {
  if (recaptchaRef.value) {
    collectibleSDK.renderRecaptcha(recaptchaRef.value, async (token: string) => {
      componentState.recaptchaToken = token;
    });
  }
});

const updatePurchaseQuantity = (qty: number) => {
  componentState.purchaseQuantity = qty;
};

const messaging = useMessaging();

const buttonText = computed(() => {
  if (store.crossmintClientId) {
    return messaging.BUY_BUTTON_WITH_ETH_CTA;
  }
  return messaging.BUY_BUTTON_CTA;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(store).walletAddress || _unref(store).crossmintClientId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(PurchaseAmount, {
              amount: componentState.purchaseQuantity,
              onChangeAmount: updatePurchaseQuantity
            }, null, 8, ["amount"]),
            _createElementVNode("div", {
              ref_key: "recaptchaRef",
              ref: recaptchaRef,
              class: "flex mx-auto"
            }, null, 512),
            _createElementVNode("button", {
              disabled: isButtonDisabled.value,
              onClick: emitPurchase
            }, _toDisplayString(buttonText.value), 9, _hoisted_4),
            (_unref(store).crossmintClientId)
              ? (_openBlock(), _createBlock(CrossmintPayButton, {
                  key: 0,
                  class: "m-crossmint-button",
                  disabled: !componentState.recaptchaToken,
                  "purchase-quantity": componentState.purchaseQuantity,
                  "recaptcha-token": componentState.recaptchaToken,
                  onClick: onCrossmintClick
                }, null, 8, ["disabled", "purchase-quantity", "recaptcha-token"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})